module.exports = __webpack_public_path__ + "static/Poyasnitelnaya_inf_k_otchetnosti_9_mes_2020-ca60f2a2b34cdd1165176e46e731fd26.pdf";